<script>
	import { push } from "svelte-spa-router";
</script>

<div class="container">
	<div class="container-header">
		<div class="header">
			<div class="top-header" />
			<div class="middle-header" />
		</div>
	</div>
	<div class="content">
		<span>Erreur 404 - Cette page n'existe pas</span>
		<input
			type="button"
			value="Retour à l'accueil"
			on:click={() => push('/')} />
	</div>
</div>
